import { NotificationIndicatorStyled } from './styled/NotificationIndicatorStyled';
import { CSSProperties } from 'react';
import classNames from 'classnames';

interface INotificationIndicatorProps {
    bottom?: CSSProperties['bottom'];
    className?: string;
    right?: CSSProperties['right'];
    size?: 'sm';
    style?: CSSProperties;
    top?: CSSProperties['top'];
}

function NotificationIndicator(props: INotificationIndicatorProps) {
    const { bottom, className, right, size, style, top } = props;

    return <NotificationIndicatorStyled
        bottom={bottom}
        className={classNames(className, {
            'sm': size === 'sm',
        })}
        right={right}
        style={style}
        top={top}
    />;
}

export default NotificationIndicator;
